import React, {useState} from 'react'

import { Button, Offcanvas } from 'react-bootstrap'
import { WallpaperOutlined } from '@mui/icons-material'

import RecursoGallery from './RecursoGallery'

const UploadImage = ({selectedImage, allImages}) => {
  const [showUpImage, setShowUpImage] = useState(false);
  const handleCloseUpImage = () => setShowUpImage(false);
  const handleShowUpImage = () => setShowUpImage(!showUpImage);
  const images = allImages
  return (
    <div className="pgi__sidebar-slides">
      <Button className='btn-form-pgi pgi__head-modules' onClick={handleShowUpImage}>Nuevo recurso<WallpaperOutlined/></Button>
    
        {/**INICIO OFF CANVAS */}
        <Offcanvas
          show={showUpImage}
          onHide={handleCloseUpImage}
          className="basePgi__pgi  pgi__sidebar-container"
          placement="end"
          scroll="true"
          enforceFocus 
          backdrop={true}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Nuevo recurso multimedia
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body> 
            
          <RecursoGallery selectedImage={null} allImages={images} closeModal={handleShowUpImage}/>
          </Offcanvas.Body>
        </Offcanvas>
    </div>
  )
}

export default UploadImage